import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpEventType } from '@angular/common/http';
import { skipWhile, first, map, mergeMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthenticationState, AuthInfo } from '../authentication-state';
import { Settings } from '../../core';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(
        private authenticationState: AuthenticationState,
        private settings: Settings
    ) { }

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<HttpEventType.Response>> {
        if (!req.url.startsWith(this.settings.apiUrl)) {
            return next.handle(req);
        }

        return this.authenticationState.authInfo
            .pipe(
                skipWhile((x: AuthInfo) => !x.isAuthenticated),
                first(),
                map(x => x.accessToken.accessToken),
                mergeMap((token) => {
                    const authReq = req.clone({
                        setHeaders: { 'Authorization': `Bearer ${token}` },
                    });

                    return next.handle(authReq);
                })
            );
    }
}